import React from 'react';
export function EmotionalCloseSection() {
  return <section className="bg-gradient-to-b from-gray-900 to-black text-white py-16 md:py-24 px-4" data-id="element-79">
      <div className="max-w-4xl mx-auto text-center" data-id="element-80">
        <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-81">
          Si venís postergando tu negocio online, este puede ser el momento de
          cambiar eso.
        </h2>

        <div className="bg-gradient-to-r from-green-600 to-blue-600 rounded-2xl p-8 md:p-12 mb-8" data-id="element-82">
          <p className="text-2xl md:text-3xl font-bold mb-6" data-id="element-83">
            No estás comprando solo un curso.
          </p>

          <p className="text-xl mb-4" data-id="element-84">Estás comprando:</p>

          <div className="grid md:grid-cols-2 gap-4 text-lg" data-id="element-85">
            {['claridad', 'estructura', 'dirección', 'velocidad', 'acompañamiento', 'y una oportunidad concreta de empezar a construir algo tuyo en internet'].map((item, index) => <div key={index} className="bg-white bg-opacity-20 rounded-lg p-4 font-semibold" data-id="element-86">
                {item}
              </div>)}
          </div>
        </div>

        <p className="text-2xl md:text-3xl font-bold text-gray-300 mb-8" data-id="element-87">
          Si querés dejar de improvisar y empezar con una base más firme,
          Dominando Shopify puede ser ese primer paso.
        </p>
      </div>
    </section>;
}